export const SUBSCRIBE_TO_IMAGE = `images/SUBSCRIBE_TO_IMAGE`
export const IMAGE_UPLOADED = `images/IMAGE_UPLOADED`
export const IMAGE_UPDATED = `images/IMAGE_UPDATED`
export const UPLOAD_IMAGES = `images/UPLOAD_IMAGES`
